module.exports = __webpack_public_path__ + "img/back.f508168d.svg";